import { useUI } from "providers/UIProvider"
import { getColumns } from "./columns"

import Table from "components/UI/organisms/Table"
import { useLanguageSettings } from "providers/LanguageSettingsProvider/LanguageSettingsProvider"

const ContentTypesTable = () => {
  const { T } = useUI()
  const { contentTypes, contentTypeInputValues, handleContentTypeInputChange } = useLanguageSettings()

  const columns = getColumns(T, contentTypeInputValues, handleContentTypeInputChange)

  return (
    <>
      <Table
        data={contentTypes}
        columns={columns}
      />
    </>
  )
}

export default ContentTypesTable